module.exports = __webpack_public_path__ + "assets/img/Rules.272a09a2.png";